import { z } from 'zod';
import { appId } from './app-v2-primitives.mjs';

const forbidden = new Set(['__proto__', 'prototype', 'constructor']);
const property = z
  .string()
  .max(128)
  .refine((value) => !/[\u0000-\u001f\u007f-\u009f]/u.test(value) && !forbidden.has(value));
const index = z.number().int().nonnegative().safe();

// Structural JSON fields/indices only. The expanded array-row path shares the
// SES capture input's sixteen-step ceiling; no query or expression dialect.
export const mediaPathSchema = z.array(z.union([property, index])).max(16);
export const mediaSourceRecipeSchema = z
  .strictObject({
    toolId: appId,
    rowsPath: mediaPathSchema.nullable(),
    imagePath: mediaPathSchema,
  })
  .superRefine((recipe, ctx) => {
    const steps =
      recipe.imagePath.length + (recipe.rowsPath === null ? 0 : recipe.rowsPath.length + 1);
    if (steps > 16)
      ctx.addIssue({
        code: 'custom',
        path: ['imagePath'],
        message: 'Expanded source image path exceeds sixteen steps',
      });
  });

export const parseMediaPath = (value) => mediaPathSchema.parse(value);
export const parseMediaSourceRecipe = (value) => mediaSourceRecipeSchema.parse(value);
